import { ValueRegistryItem } from '../../../registry/value/ValueRegistryItem';
import { ValueRegistryCategory } from '../../../registry/value/ValueRegistryCategory';
export class ValuesOrderedChoice extends ValueRegistryCategory {
    label = 'Question OrderedChoice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    orderedTaskStep_latestXClick = () => new ValueRegistryItem({
        label: 'X of latest step selection click',
        value: context => {
            if (!context.step)
                return 0;
            const step = context.step;
            if (!step.stepState.latestSelectionEvent)
                return 0;
            return step.stepState.latestSelectionEvent.stageXInUnits;
        }
    });
    orderedTaskStep_latestYClick = () => new ValueRegistryItem({
        label: 'Y of latest step selection click',
        value: context => {
            if (!context.step)
                return 0;
            const step = context.step;
            if (!step.stepState.latestSelectionEvent)
                return 0;
            return step.stepState.latestSelectionEvent.stageYInUnits;
        }
    });
}
